import React from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '../../components/Modal';
import { getLocalizedHelpCenterMeta } from './localization';
import { getHelpCenterContentBySlug } from './registry';
import * as s from './styles';

type Props = {
  showModal: boolean;
  closeModal: () => void;
  slug: string;
  maximized?: boolean;
};

const HelpCenterModal: React.FC<Props> = ({
  showModal,
  closeModal,
  slug,
  maximized = false,
}) => {
  const { t, i18n } = useTranslation();

  const contentDefinition = getHelpCenterContentBySlug(slug, 'modal');
  const contentTitle = contentDefinition
    ? getLocalizedHelpCenterMeta(contentDefinition, i18n.resolvedLanguage ?? i18n.language).title
    : t('helpCenter');

  return (
    <Modal
      title={contentTitle}
      showModal={showModal}
      closeModal={closeModal}
      onlyCloseButton
      maximized={maximized}
    >
      {contentDefinition ? (
        <contentDefinition.Content mode="modal" />
      ) : (
        <s.EmptyState>
          <h3>{t('helpCenterContentUnavailableTitle')}</h3>
          <p>{t('helpCenterContentUnavailableDescription')}</p>
        </s.EmptyState>
      )}
    </Modal>
  );
};

export default HelpCenterModal;
